import React from 'react';
import styled from '@emotion/styled';

import { Colors } from '../constants';
import * as Articles from '../routes/articles';

const Container = styled.div`
  width: 100%;

  font-size: 14px;
  line-height: 1.55;
  color: ${Colors.Text.Faint.base};
`;

const Intro = styled.div`
  margin-bottom: 2rem;
`;

const Name = styled.div`
  font-family: 'Roboto Slab', serif;
  font-size: 18px;
  font-weight: 400;
  color: ${Colors.Text.base};
  margin-bottom: 0.35em;
`;

const Role = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${Colors.Text.Faint.base};
`;

const RoleLink = styled.a`
  color: ${Colors.Text.base};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: ${Colors.Text.hover};
  }

  &:active {
    color: ${Colors.Text.active};
  }
`;

const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${Colors.Text.Faint.base};
  margin-bottom: 0.75em;
`;

const ArticleList = styled.div`
  border-top: 1px solid ${Colors.Container.border};
  padding-top: 1.5rem;
`;

const ArticleElement = styled.a`
  display: block;

  margin-top: 0.65em;
  margin-bottom: 0.65em;

  color: ${Colors.Text.base};
  text-decoration: none;
  line-height: 1.4;

  &:hover {
    color: ${Colors.Text.hover};
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  &:active {
    color: ${Colors.Text.active};
  }
`;

function Sidebar() {
  return (
    <Container>
      <Intro>
        <Name>Jake Kinsella</Name>
        <Role>
          Co-Founder + Lead Architect at{' '}
          <RoleLink href="https://www.latentspin.ai" target="_blank" rel="noreferrer">
            LatentSpin
          </RoleLink>
          . Building agents that learn from teaching — real-time learning for agentic AI.
        </Role>
      </Intro>

      <ArticleList>
        <SectionLabel>Recent</SectionLabel>
        {Articles.All.map((article) => (
          <ArticleElement key={article.path} href={article.path}>
            {article.title}
          </ArticleElement>
        ))}
      </ArticleList>
    </Container>
  );
}

export default Sidebar;
